import React from 'react'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import EnvelopActionPanelDesktop from './EnvelopActionPanelDesktop'
import EnevelopActionPanelMobile from './EnvelopActionPanelMobile'

interface EnevelopActionPanelProps {
    showActionLink?: boolean
    isCompleted?: boolean
    actionLink: string
    state: any
}

const EnevelopActionPanel: React.FC<EnevelopActionPanelProps> = (props) => {
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up('md'))

    return matches ? <EnvelopActionPanelDesktop {...props} /> : <EnevelopActionPanelMobile {...props} />
}

export default EnevelopActionPanel
